import { Typography } from "@mui/material";
import { Box, Grid } from "@mui/system";

interface Props {
  interfaceRow: any;
}

const InterfaceHead = ({ interfaceRow }: Props) => {
  const cards = [
    {
      title: "FAMILIES",
      count: interfaceRow?.families ?? "N/A",
    },
    {
      title: "BRANDS",
      count: interfaceRow?.brands_total ?? "N/A",
    },
    {
      title: "MAPS/CONFIGS",
      count: interfaceRow?.maps_total ?? "N/A",
    },
  ];

  return (
    <>
      <Box sx={{ padding: "16px 16px 0px" }}>
        <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
          <Grid size={12}>
            <Typography variant="h3" sx={{ fontSize: "24px" }}>
              {interfaceRow?.interface_name ?? "N/A"}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              Interface:{" "}
              <span style={{ fontWeight: 500 }}>
                #{interfaceRow?.backend_interface_id ?? "N/A"}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ padding: "10px 16px 16px" }}>
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            width: "100%",
          }}
        >
          {cards.map((card, index) => (
            <Box
              key={index}
              sx={{
                flex: 1,
                display: "flex",
                width: "100%",
                border: "1px solid #0000001F",
                borderRadius: "8px",
                padding: "8px",
                height: "48px",
                boxSizing: "border-box",
                alignItems: "center",
              }}
            >
              {/* Title + Count */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "#00000099",
                    }}
                  >
                    {card.title}
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: 700,
                    color: "#292929",
                    lineHeight: 1,
                  }}
                >
                  {card.count}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default InterfaceHead;
